import { TreatmentStatusTabValue } from "./TreatmentStatusTabs";
import CONSTANTS from "core/constants";
import type { BookingStatus, SearchTerms, Booking } from "./types";

const SEARCH_TERMS = CONSTANTS.SEARCH_TERMS;
const TREATMENT_EVENT_TYPE = CONSTANTS.TREATMENT_EVENT_TYPE;
const PATIENT_BOOKING_TYPES = CONSTANTS.PATIENT_BOOKING_TYPES;

export const termToSearchField: Record<string, keyof SearchTerms> = {
  [SEARCH_TERMS.FIRSTNAME]: "patientFirstName",
  [SEARCH_TERMS.LASTNAME]: "patientLastName",
  [SEARCH_TERMS.NATIONAL_IDENTITY]: "nationalIdentity",
  [SEARCH_TERMS.EMAIL]: "email",
  [SEARCH_TERMS.USER_ID]: "userId",
};

export const treatmentStatusTranslationKeyMap: Record<
  NonNullable<TreatmentStatusTabValue>,
  string
> = {
  [TREATMENT_EVENT_TYPE.TREATMENT_START]: "TREATMENT_ACTIVE",
  [TREATMENT_EVENT_TYPE.TREATMENT_END]: "TREATMENT_ENDED",
};

export const bookingStatuses: Array<{
  value: BookingStatus | undefined;
  translationKey: string;
}> = [
  { value: undefined, translationKey: "ALL" },
  {
    value: PATIENT_BOOKING_TYPES.ONGOING as BookingStatus,
    translationKey: "PATIENT_FILTER_ONGOING",
  },
  {
    value: PATIENT_BOOKING_TYPES.UNSCHEDULED as BookingStatus,
    translationKey: "PATIENT_FILTER_UNSCHEDULED",
  },
  {
    value: PATIENT_BOOKING_TYPES.NEW as BookingStatus,
    translationKey: "PATIENT_FILTER_NEW",
  },
  {
    value: PATIENT_BOOKING_TYPES.UPCOMING_WITH_COLLEAGUE as BookingStatus,
    translationKey: "PATIENT_FILTER_UPCOMING_WITH_COLLEAGUE",
  },
];

export const sortByBookingDate =
  (key: "previousBooking" | "nextBooking") =>
  (
    rowA: { original: { [k in typeof key]: Booking } },
    rowB: { original: { [k in typeof key]: Booking } },
  ) => {
    const a = rowA.original[key]?.slotStartsAt ?? "";
    const b = rowB.original[key]?.slotStartsAt ?? "";
    return a < b ? -1 : a > b ? 1 : 0;
  };
